import { useState, useEffect } from 'react';
import { Alert, AlertTitle, Box, Button, IconButton, Snackbar, Typography } from "@mui/material";
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import CloseIcon from '@mui/icons-material/Close';
import { version } from '../../../config/version';
import { getLatestVersion } from '../../../features/changelog/utils/changelog';
import { useTranslation } from 'react-i18next';

const CHECK_INTERVAL = 5 * 60 * 1000;

export default function UpdateAlert() {
  const { t } = useTranslation(["common"])
  const [open, setOpen] = useState(false);
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    const checkForUpdates = () => {
      fetch('/changelog.json?t=' + (+new Date()))
        .then(res => res.json())
        .then(data => {
          const latestVersion = getLatestVersion(data);

          if (latestVersion && latestVersion !== version) {
            setHasUpdate(true);
            setOpen(true);
          }
        })
        .catch(err => console.error('Failed to fetch changelog:', err));
    };

    checkForUpdates();
    const interval = setInterval(checkForUpdates, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return (
    <Snackbar
      open={open && hasUpdate}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      onClose={(event, reason) => { if (reason !== 'clickaway') setOpen(false); }}
    >
      <Alert
        severity="info"
        variant="outlined"
        icon={<SystemUpdateAltIcon fontSize="inherit" />}
        action={
          <Box display="flex" alignItems="center" gap={0.5}>
            <Button
              color="info"
              size="small"
              variant="contained"
              disableElevation
              onClick={() => window.location.reload()}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {t("common:update.action")}
            </Button>
            <IconButton size="small" color="inherit" aria-label="close" onClick={() => setOpen(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        }
        sx={{
          alignItems: 'center',
          bgcolor: 'background.paper',
          boxShadow: 6,
          '& .MuiAlert-action': { pt: 0, pr: 0.5, alignItems: 'center' },
        }}
      >
        <AlertTitle sx={{ mb: 0, fontWeight: 600 }}>{t("common:update.title")}</AlertTitle>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {t("common:update.avaliable")}
        </Typography>
      </Alert>
    </Snackbar>
  );
}
